const isPreview = (query)=>{
    return query && typeof query.token === 'string';
};

export { isPreview };
//# sourceMappingURL=utils.js.map
